// extracted by mini-css-extract-plugin
module.exports = {"loading-screen":"LoadingSpinner_loading-screen__4hpI0","ldsRing":"LoadingSpinner_ldsRing__3C6Xm"};